export const validation = {
  headingMaxChar: 10,
  paragraphMaxChar: 60,
  images: {
    min: 1,
    max: 11
  }
}